import React from 'react'
import "./Withdraw_tab_contant.css"
import { Button, Form } from 'react-bootstrap'
import Successfull_Modal from '../../common_components/common_modal/successfull_modal/Successfull_Modal';
import Success_Lottie from '../../animations/success_lottie/Success_Lottie';
import Proceed_btn from '../../common_components/common_btn/proceed_btn/Proceed_btn';

function Withdraw_tab_contant() {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <>
            <section className='Withdraw_tab_contant '>
                <div className=" withdraw-box">
                    <div className="withdraw-header">
                        <div className="withdraw-header-left">
                            <p className="withdraw-title">Withdraw Money to</p>
                        </div>
                        <button className="update-account-btn">Update Account</button>
                    </div>

                    <div className="withdraw-account-card">
                        <div className="withdraw-bank-info">
                            <div>
                                <div className="img_holder">
                                    <img src="/assets/images/services/bank_logo/bank_of_maharashtra.png" alt="" className='wallet_card_img' />
                                </div>
                            </div>
                            <div className="bank-details">
                                <p className="bank-title">Primary Bank Account</p>
                                <p className="bank-number">76********930</p>
                            </div>
                        </div>
                    </div>
                    <div className="wallet-input-box">
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter Amount</Form.Label>
                                <Form.Control type="email" placeholder="Enter Amount" value="₹" />
                            </Form.Group>
                        </Form>
                    </div>
                </div>

                <Proceed_btn btnText="Withdraw Amount" onClick={() => setModalShow(true)}/>





            </section>

            <Successfull_Modal
                show={modalShow}
                message=" Withdrawal Successful!"
                subMessage ="Your payment has been released and will reflect in your account shortly."
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />
        </>
    )
}

export default Withdraw_tab_contant